import { useDynamicConfig } from '@statsig/react-bindings';

import { useDiscountContext } from '../[locale]/product/_contexts/DiscountProvider';

/**
 * Temporary hook to mimic the behavior seen during the black friday sitewide period where the old
 * MSRP is used as the strikethrough instead of the actual MSRP to visually inflate the discount amount
 *
 * Only used for the natural cycles BF discount
 */
function useShowOldPrice(): boolean {
  const { appliedDiscountCode } = useDiscountContext();

  const eligibleDiscountsConfig = useDynamicConfig(
    'display_old_price_discounts',
  );
  const eligibleDiscounts = eligibleDiscountsConfig.get<string[]>(
    'discounts',
    [],
  );
  return eligibleDiscounts.includes(appliedDiscountCode);
}

export default useShowOldPrice;
